import React from "react";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";

export interface CommonLayoutProps {
  index: string;
  nextHref: string;
  backtHref: string;
  nextBtnText?: string;
  children: React.ReactNode;
  onSubmit?: any;
  hideBackBtn?: boolean;
}

const CommonLayout: FC<CommonLayoutProps> = ({
  index = "01",
  children,
  nextHref,
  nextBtnText,
  backtHref,
  onSubmit = null,
  hideBackBtn = false,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(backtHref, { 
      state: { preserveFormData: true }
    });
  };
  
  return (
    <div
      className={`nc-PageAddListing1 px-4 max-w-3xl mx-auto pb-24 pt-14 sm:py-24 lg:pb-32`}
      data-nc-id="PageAddListing1"
    >
      <div className="space-y-11">
        <div>
          <span className="text-4xl font-semibold">{index}</span>{" "}
          <span className="text-lg text-neutral-500 dark:text-neutral-400">
            / 2
          </span>
        </div>

        {/* --------------------- */}
        <div className="listingSection__wrap ">{children}</div>

        {/* --------------------- */}
        <div className="flex justify-end space-x-5">
          {!hideBackBtn && <ButtonSecondary onClick={handleBack}>Go back</ButtonSecondary>}
          {
            (onSubmit) ? (
              <ButtonPrimary onClick={onSubmit}>
                {nextBtnText || "Continue"}
              </ButtonPrimary>
            ) : (
              <ButtonPrimary href={nextHref}>
                {nextBtnText || "Continue"}
              </ButtonPrimary>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default CommonLayout;
